import { makeStyles } from '@material-ui/core'

import { lang } from '../../../../localization'
import { monitoringGridColumns } from './monitoringGrid'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    // Shared with the row — see monitoringGrid. Hand-maintained copies had drifted at every
    // breakpoint below 1800px, which is the reported column misalignment.
    gridTemplateColumns: monitoringGridColumns.base,
    alignItems: 'center',
    paddingLeft: 12,
    color: 'grey',
    marginTop: 20,
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    marginBottom: 4,
    [theme.breakpoints.between(1360, 1800)]: {
      gridTemplateColumns: monitoringGridColumns.medium
    },

    [theme.breakpoints.down(1200)]: {
      width: '1250px'
    },

    [theme.breakpoints.down(1360)]: {
      gridTemplateColumns: monitoringGridColumns.small
    }
  },
  text: {
    fontWeight: 800,

    [theme.breakpoints.between(1360, 1440)]: {
      fontSize: lang === 'en' ? 14 : 13,
      fontWeight: 800
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: lang === 'en' ? 16 : 14,
      fontWeight: 800
    },

    [theme.breakpoints.down(1360)]: {
      fontSize: lang === 'en' ? 14 : 13,
      fontWeight: 800
    },
    [theme.breakpoints.down(1200)]: {
      fontSize: lang === 'en' ? 16 : 14,
      fontWeight: 800
    }
  }
}))
export default useStyles
